import React from 'react';
import PropTypes from 'prop-types';
import { Body1 } from '@xo-union/tk-ui-typography';
import Modal from '@xo-union/tk-component-modals';
import FormButtons from '~/glm/components/shared/form-buttons';
import styles from './styles.scss';

const BulkDeleteModal = ({ onClose, numberOfGuestsDeleted, onAccept }) => {
  const plural = numberOfGuestsDeleted > 1;

  return (
    <Body1>
      <Modal onClose={onClose}>
        <h3>
          Delete {numberOfGuestsDeleted} Guest{plural ? 's' : ''}?
        </h3>
        <p className={styles.details}>
          Don&#39;t stress&mdash;changing your guest list is a normal part of the planning process!
        </p>
        <p className={styles.details}>Once you delete these {numberOfGuestsDeleted} guest(s), we&#39;ll:</p>
        <ul>
          <li>Remove them from every event you&#39;ve added them to (along with their +1s).</li>
          <li>Ungroup their parties.</li>
        </ul>
        <p className={styles.details}>Just so you know, this action is permanent and can&#39;t be undone.</p>
        <FormButtons confirmCallback={onAccept} cancelCallback={onClose} confirmLabel="Yes, Delete" />
      </Modal>
    </Body1>
  );
};

BulkDeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  numberOfGuestsDeleted: PropTypes.number,
};

export default BulkDeleteModal;
